import { Injectable } from '@angular/core';
import { ZOAConnectionStore } from './oa-connection.store';
import { ZaloApi } from '@etop/api/shop/zalo.api';

@Injectable({
  providedIn: 'root',
})
export class OAConnectionService {
  constructor(
    private oaStore: ZOAConnectionStore,
    private zaloApi: ZaloApi
  ) {}

  async getConnectShopOA() {
    try {
      return await this.zaloApi.getZaloConnection();
    } catch (e) {
      debug.error('ERROR in getConnectShopOA', e);
    }
  }

  async getListShopOA() {
    this.setLoading(true);
    try {
    const res = await this.zaloApi.listShopOA();
    this.oaStore.set(res);
    } catch (e) {
      debug.error('ERROR in getConnectShopOA', e);
    }
    this.setLoading(false);
  }

  async tagFollower(oa_id: string, tag_name: string, zl_user_id: string) {
    try {
      return await this.zaloApi.tagFollower(oa_id, tag_name, zl_user_id);
    } catch (e) {
      debug.error('ERROR in tagFollower', e);
    }
  }

  async removeTagOfOA(oa_id: string, tag_name: string) {
    try {
      return await this.zaloApi.removeTagOfOA(oa_id, tag_name);
    } catch (e) {
      debug.error('ERROR in removeTagOfOA', e);
    }
  }

  async removeTagFromFollower(oa_id: string, tag_name: string, zl_user_id: string) {
    try {
      return await this.zaloApi.removeTagFromFollower(oa_id, tag_name, zl_user_id);
    } catch (e) {
      debug.error('ERROR in removeTagFromFollower', e);
    }
  }

  async getTagOA(oa_id: string) {
    try {
      return await this.zaloApi.getTagsOfOA(oa_id);
    } catch (e) {
      debug.error('ERROR in getTagOA', e);
    }
  }

  setLoading(loading: boolean) {
    this.oaStore.setLoading(loading);
  }

  setActive(id: string) {
    this.oaStore.setActive(id);
  }
}
